(ns ui.components.modal.view
  (:require
   [common.localization :as loc]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.style :as style]
   [ui.components.modal.zapkit-styles :as zapkit-styles]
   [ui.util :as uu]))

;;WARNING. Timo, Mikko. - Check buttons conditions. With new components logic is broken

(defn- tw2-styles?
  [variant]
  (= variant :tw2-styles))

(defn- close-button
  "The header's X, named so a screen reader announces something better than
   an unnamed button."
  [hide!]
  (when hide!
    [button/square-secondary-open
     {:tooltip    (loc/tr :close)
      :aria-label (loc/tr :close)
      :on-click   hide!}
     [:i
      {:class "fal fa-times text-xl"}]]))

(defn- header
  [title-child {:keys [header-class header-child-class hide! close-button?]}]
  (when (or title-child close-button?)
    [:div
     {:class (uu/cm "p-4 lg:px-6 flex justify-between items-center gap-4 text-xl font-semibold text-base-regular-text bg-base-regular border-b border-solid border-base-regular-border-paler"
                    header-class)}
     [:div
      {:class (uu/cm header-child-class)}
      title-child]
     [close-button hide!]]))

(defn- body
  [child {:keys [body-class]}]
  (into
   [:div
    {:class (uu/cm "p-4 lg:p-6 flex flex-col flex-1 text-base-light-text overflow-auto"
                   body-class)}]
   [(or child "")]))

(defn- footer
  [child]
  (into
   [:div
    {:class "py-3 px-4 lg:px-6 flex justify-between items-center gap-4 border-t border-solid border-base-light-border-paler"}]
   [child]))

(defn- modal-content
  [{:keys [size outer-content-class content-class] :as props}
   title-child body-child footer-child]
  (let [;; A string `size` is an arbitrary value only known at runtime, so it
        ;; cannot become a Tailwind class. JIT emits `w-[720px]` only when that
        ;; exact literal appears in a scanned file, and a class assembled with
        ;; `str` never does - so the rule simply did not exist and the modal
        ;; fell back to the `w-full` on the same element, rendering full-bleed.
        ;; It looked like `:size` worked because "800px", "1024px" and "80vw"
        ;; appear as literals in the keyword branches below; "720px" and
        ;; "900px", which only ever arrive as data, silently did nothing.
        ;; Arbitrary runtime dimensions belong in an inline style instead.
        custom-width (when (string? size) size)
        size-classes (cond
                       (string? size)
                       ;; width comes from `custom-width` below
                       "p-0 max-w-[100vw]"

                       (keyword? size)
                       (case size
                         ::style/full "p-4 w-full h-full"
                         ::style/lg "p-0 w-[80vw]"
                         ::style/md "p-0 w-[800px] max-w-[100vw]"
                         "p-0 w-[800px] max-w-[100vw]")

                       :else
                       "p-0 w-[800px] max-w-[100vw]")]
    [:div
     {:class (uu/cm
              "flex flex-col items-center justify-center"
              "w-full fixed top-0 bottom-0 left-0 right-0"
              "z-[1055] bg-black/[.5]"
              outer-content-class)}
     [:div
      {;; `w-full` is dropped for a custom width: the Tailwind config sets
       ;; `important: true`, so `w-full` carries !important and would win
       ;; over the inline width below.
       :class (uu/cm (if custom-width
                       "mx-auto flex flex-col items-center"
                       "w-full mx-auto flex flex-col items-center")
                     (case size
                       ::style/full "max-h-[100vh]"
                       "max-h-[90vh]")
                     size-classes
                     content-class)
       :style (when custom-width {:width custom-width})}
      [:div
       {:class (uu/cm "h-full w-full
                     flex flex-col
                     bg-base-light
                     overflow-auto
                     shadow rounded")}
       [header title-child props]
       [body body-child props]
       (when footer-child
         [footer footer-child])]]]))


(defn left-cancel-only
  [on-click dom-id]
  [:div
   {:class "flex gap-2 justify-start items-center"}
   [button/secondary-hollow
    {:on-click on-click
     :dom-id   dom-id}
    (loc/tr :cancel)]])

(defn right-single-button
  ([color disabled? on-click text dom-id]
   (right-single-button color disabled? on-click text dom-id nil))
  ([color disabled? on-click text dom-id tooltip]
   [:div
    {:class "flex gap-2 justify-end items-center ml-auto"}
    (cond (nil? color)
          [button/primary-solid
           {:disabled? disabled?
            :dom-id    dom-id
            :tooltip   tooltip
            :on-click  on-click}
           text]
          (= color ::c/danger)
          [button/danger-solid
           {:disabled? disabled?
            :dom-id    dom-id
            :tooltip   tooltip
            :on-click  on-click}
           text]
          :else
          (do (js/console.log "Unexpected single button color : " color)
              [button/primary-solid
               {:disabled? disabled?
                :dom-id    dom-id
                :tooltip   tooltip
                :on-click  on-click}
               text]))]))

(defn left-single-button
  [color disabled? on-click text]
  [:div
   {:class "flex gap-2 justify-start items-center"}
   (cond (nil? color)
         [button/secondary-hollow
          {:disabled? disabled?
           :on-click  on-click}
          text]
         (= color ::c/danger)
         [button/danger-solid
          {:disabled? disabled?
           :on-click  on-click}
          text]
         :else
         (do (js/console.log "Unexpected single button left color : " color)
             [button/secondary-hollow
              {:disabled? disabled?
               :on-click  on-click}
              text])
         )])

(defn left-single-button-hollow
  [color disabled? on-click text]
  [:div
   {:class "flex gap-2 justify-start items-center"}
   (cond (nil? color)
         [button/secondary-hollow
          {:disabled? disabled?
           :on-click  on-click}
          text]
         (= color ::c/danger)
         [button/danger-solid
          {:disabled? disabled?
           :on-click  on-click}
          text]
         :else
         (do (js/console.log "Unexpected single button hollow left color : " color)
             [button/secondary-hollow
              {:disabled? disabled?
               :on-click  on-click}
              text])
         )])

(defn footer-left-only
  [& children]
  (into
   [:div
    {:class "flex gap-2 justify-start items-center"}]
   children))

(defn footer-children-left-and-right
  [left-children right-children]
  [:<>
   (into [:div
          {:class "flex gap-2 justify-start items-center"}]
         left-children)
   (into [:div
          {:class "flex gap-2 justify-end items-center"}]
         right-children)])

(defn footer-left-and-right
  [left-children right-children]
  [:div
   {:class "py-3 px-4
             flex gap-4
             border-t border-solid border-base-light-border-paler"}
   (into [:div
          {:class "flex gap-2 justify-start items-center"}]
         left-children)
   (into [:div
          {:class "flex gap-2 justify-end items-center"}]
         right-children)])

(defn tw2-panel-size-classes
  "Size overrides for the panel, which the generated panel base pins to the
   upstream default (`tw2-w-md tw2-max-w-md tw2-max-h-modal-max-height`,
   centered with `tw2-top-1/2 tw2-left-1/2` and the negative translates).

   `uu/cm` resolves most of those: `max-w-*`, `max-w-none` and `inset-*`
   (over `top`/`left`) all drop the base class. It does not recognize `w-md`
   as a width value, nor the upstream negative-translate spelling (a leading
   `-` after the prefix rather than before it), so those three would be left
   to stylesheet order — hence the `!` on the width, max-height and translate
   overrides only.

   A string `size` is an arbitrary runtime value and never becomes a class at
   all: JIT only emits `tw2-w-[720px]` when that literal appears in a scanned
   file, so it is applied as an inline width by the caller instead. Only the
   max-width is overridden here, or the base `tw2-max-w-md` would clamp that
   inline width to 28rem. No `!` on it: `important` is `.tw2` in the tw2
   config, a selector scope rather than `!important`, so an inline style still
   wins over the base `tw2-w-md`."
  [size]
  (cond
    (string? size)
    ;; width comes from the inline style on the panel
    "tw2-max-w-[calc(100vw-2rem)]"

    (keyword? size)
    (case size
      ::style/full
      "tw2-inset-4 !tw2-w-auto tw2-h-auto tw2-max-w-none !tw2-max-h-[calc(100vh-2rem)] !tw2-translate-x-0 !tw2-translate-y-0"
      ::style/lg "!tw2-w-[80vw] tw2-max-w-[80vw]"
      ::style/md "!tw2-w-[800px] tw2-max-w-[calc(100vw-2rem)]"
      "!tw2-w-[800px] tw2-max-w-[calc(100vw-2rem)]")

    :else
    "!tw2-w-[800px] tw2-max-w-[calc(100vw-2rem)]"))

(defn tw2-modal-content
  "Mirrors the upstream ZapKit `Modal` structure: the overlay and the panel are
   siblings, and the panel itself carries the surface (background, radius,
   shadow, padding, gap) — there is no inner content wrapper.

   The legacy `modal-content` class props map onto that structure as:
   `outer-content-class` -> overlay, `content-class` -> panel,
   `header-class` -> header, `header-child-class` -> title,
   `body-class` -> content."
  [{:keys [visible? class size hide! close-button? outer-content-class
           content-class header-class header-child-class body-class]
    :as _props}
   title-child
   body-child
   footer-child]
  (let [styles zapkit-styles/modal
        custom-width (when (string? size) size)]
    [:div
     {:class (uu/cm "tw2" class)}
     [:div
      {:class (uu/cm (get-in styles [:overlay :base])
                     (if visible?
                       (get-in styles [:overlay :visible])
                       (get-in styles [:overlay :hidden]))
                     outer-content-class)}]
     [:div
      {:class (uu/cm (get-in styles [:panel :base])
                     (if visible?
                       (get-in styles [:panel :visible])
                       (get-in styles [:panel :hidden]))
                     (tw2-panel-size-classes size)
                     content-class)
       :style (when custom-width {:width custom-width})
       :role "dialog"
       :aria-modal "true"}
      (when (or title-child close-button?)
        [:div
         {:class (uu/cm (get-in styles [:header :base])
                        header-class)}
         [:div
          {:class (get-in styles [:header :row])}
          (when title-child
            [:h2
             {:class (uu/cm (get-in styles [:header :title])
                            header-child-class)}
             title-child])
          (when hide!
            [button/square-secondary-open
             {:on-click hide!}
             [:i
              {:class "fal fa-times text-xl"}]])]])
      [:div
       {:class (uu/cm (get-in styles [:content :base])
                      body-class)}
       body-child]
      (when footer-child
        [:div
         {:class (get-in styles [:footer :base])}
         footer-child])]]))

(defn view
  "Return a modal components accepting:
   - `props`
   - `body-child`: body of the modal
   - `footer-child`: optional footer of the modal

   If you need more than one component for body or footer, wrap them in a `div`."
  ;; To close the modal when user clicks out of it, we could use
  ;; `stopPropagation` but it looks rather controversial [0] and not without
  ;; consequences. Instead, in this component, we declare four transparent
  ;; components (North/West/East/South) on which we are able to detect a click.
  ;; [0]:
  ;; https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
  [{:keys [visible? class] :as props}
   title-child
   body-child
   footer-child]
  (when visible?
    (if (tw2-styles? (:variant props))
      [tw2-modal-content
       props
       title-child
       body-child
       footer-child]
      [:div
       {:class (uu/cm "w-full h-full
                   fixed z-[302] left-0 top-0
                   overflow-auto"
                      (if visible?
                        "block"
                        "hidden")
                      class)}
       [modal-content
        props
        title-child
        body-child
        footer-child]])))
